import { render, staticRenderFns } from "./OtherEntity.vue?vue&type=template&id=0d133747&"
import script from "./OtherEntity.vue?vue&type=script&lang=js&"
export * from "./OtherEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports